import React from 'react';

interface FilterTabsProps {
  filters: string[];
  selected: string;
  onSelect: (filter: string) => void;
  className?: string;
}

const FilterTabs: React.FC<FilterTabsProps> = ({ filters, selected, onSelect, className = '' }) => (
  <>
    {/* Mobile: Dropdown/Select */}
    <div className={`sm:hidden ${className}`}>
      <select
        value={selected}
        onChange={(e) => onSelect(e.target.value)}
        className="w-full p-3 rounded-md border border-gray-200 focus:ring-2 focus:ring-primary-100 focus:outline-primary-200 text-sm bg-white"
      >
        {filters.map((filter) => (
          <option key={filter} value={filter}>
            {filter}
          </option>
        ))}
      </select>
    </div>

    {/* Desktop: Tabs */}
    <div className={`hidden sm:flex space-x-4 lg:space-x-8 border-b border-gray-200 flex-1 ${className}`}>
      {filters.map((filter) => (
        <button
          key={filter}
          className={`pb-2 text-sm lg:text-base font-medium focus:outline-primary-200 transition-colors duration-200 whitespace-nowrap
            ${selected === filter
              ? 'text-primary-600 border-b-2 border-primary-600'
              : 'text-gray-500 border-b-2 border-transparent hover:text-primary-600'}
          `}
          onClick={() => onSelect(filter)}
          style={{ background: 'none', boxShadow: 'none' }}
          type="button"
        >
          {filter}
        </button>
      ))}
    </div>
  </>
);

export default FilterTabs; 